// Components
import LmGridEntityLink from '@components/ag-grid-helpers/EntityLink'

export default {
  computed: {
    actions() {
      if (this.importFile) {
        return [
          {
            label: 'Download import file',
            event: 'download-file',
            type: 'button',
            color: 'tertiary',
            size: 'md'
          }
        ]
      }
      return []
    },
    gridOptions() {
      return {
        rowData: this.agGridRows,
        rowSelection: 'single',
        columnDefs: [
          {
            headerName: 'Publisher/Vendor name',
            field: 'name',
            tooltipValueGetter: params => (params.value ? params.value : 'N/A'),
            cellRendererParams: params => {
              if (!params || !params.value) return
              return {
                customData: {
                  id: params.data.id,
                  routeName: params.data.type,
                  label: params.value,
                  newTab: false
                }
              }
            },
            cellRendererFramework: LmGridEntityLink
          },
          {
            headerName: 'Alternative name',
            field: 'alternative_name',
            cellRenderer: params => params.value || 'N/A',
            tooltipValueGetter: params => params.value
          },
          {
            headerName: 'Abbreviation',
            field: 'abbreviation',
            cellRenderer: params => params.value || 'N/A',
            tooltipValueGetter: params => params.value
          },
          {
            headerName: 'Currency',
            field: 'currency',
            cellRenderer: params => params.value || 'N/A',
            tooltipValueGetter: params => params.value
          },
          {
            headerName: 'Website',
            field: 'website',
            cellRenderer: params => params.value || 'N/A',
            tooltipValueGetter: params => params.value
          },
          {
            headerName: 'Active',
            field: 'active',
            cellRenderer: params => (params.value ? 'Yes' : 'No'),
            tooltipValueGetter: params => (params.value ? 'Yes' : 'No')
          },
          {
            headerName: 'Ringgold identifier',
            field: 'ringgold_id',
            cellRenderer: params => params.value || 'N/A',
            tooltipValueGetter: params => params.value || 'N/A'
          },
          {
            headerName: 'Customer account number',
            field: 'customer_account_number',
            cellRenderer: params => params.value || 'N/A',
            tooltipValueGetter: params => params.value || 'N/A'
          }
        ]
      }
    }
  }
}
